// Tailwind v4 entry (has @import "tailwindcss", @source, @theme)
import "../css/app.css";

const base = import.meta.glob("../css/tw/base/*.css");
Object.keys(base)
  .sort()
  .forEach((k) => base[k]());

// Components (sorted alphabetical; prefix files if you need a strict order)
const comps = import.meta.glob("../css/tw/components/*.css");
Object.keys(comps)
  .sort()
  .forEach((k) => comps[k]());

// Layout partials
const layouts = import.meta.glob("../css/tw/layout/*.css");
Object.keys(layouts)
  .sort()
  .forEach((k) => layouts[k]());

// Your SCSS (fonts, mixins, components). No Tailwind directives here.
import "../css/fonts.scss";
import "../css/app.scss";

// 👇 Add these imports
// import "./header-image.js";
import "./article-citations.js";
import "./article-toc.js";
import "./bar-chart.js";
import "./clicks.js";
import "./column-layout.js";
import "./insights-filter.js";
import "./navigation.js";
import "./outcomes.js";
import "./read-depth.js";
import "./proof-carousel.js";
import "./stat-panel.js";
import "./sticky-header.js";
import "./tool-tabs.js";
import "./systems.js";
import "./why-testimonial.js";

// --- your existing behavior code ---
(function (Drupal, once) {
  Drupal.behaviors.keidoEdge = {
    attach(context) {
      once("keidoEdgeScroll", window).forEach(() => {
        const header = document.querySelector(".k-header");
        const onScroll = () =>
          header?.classList.toggle("k-header--shadow", window.scrollY > 8);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
      });

      // once("keidoEdgeMenu", context.querySelectorAll(".k-header")).forEach(
      //   () => {
      //     const menuBtn = context.querySelector("[data-k-menu-btn]");
      //     const menu = context.querySelector("[data-k-menu]");
      //     if (menuBtn && menu) {
      //       menuBtn.addEventListener("click", () => {
      //         const open = menu.getAttribute("data-open") === "true";
      //         menu.setAttribute("data-open", String(!open));
      //         menu.hidden = open;
      //         menuBtn.setAttribute("aria-expanded", String(!open));
      //       });
      //       menu.addEventListener("click", (e) => {
      //         const a = e.target.closest("a");
      //         if (a && window.getComputedStyle(menu).display !== "none") {
      //           menu.hidden = true;
      //           menu.setAttribute("data-open", "false");
      //           menuBtn.setAttribute("aria-expanded", "false");
      //         }
      //       });
      //     }
      //   }
      // );
    },
  };
})(Drupal, once);
